class Link {
  constructor() {
    this.links = document.querySelectorAll('.js-target-blank');
    this.linksArray = Array.prototype.slice.call(this.links);
    if(this.links){
      this.addTargetBlank();
    }
  }

  addTargetBlank(){
    this.linksArray.forEach((link, i) => {
      if(link.tagName == 'A'){
        link.setAttribute('target', '_blank');
      } else {
        link.querySelector('a').setAttribute('target', '_blank');
      }
    });
  }
}

export default Link;
